'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = exports.createTemplateTag = exports.ResolveValue = exports.resolveObject = exports.extractValueWithPath = exports.Provider = exports.default = exports.FunctionTree = exports.Path = exports.createStaticTree = exports.Primitive = exports.FunctionTreeError = exports.FunctionTreeExecutionError = undefined;

var _errors = require('./errors');

Object.defineProperty(exports, 'FunctionTreeExecutionError', {
  enumerable: true,
  get: function get() {
    return _errors.FunctionTreeExecutionError;
  }
});
Object.defineProperty(exports, 'FunctionTreeError', {
  enumerable: true,
  get: function get() {
    return _errors.FunctionTreeError;
  }
});

var _primitives = require('./primitives');

Object.defineProperty(exports, 'Primitive', {
  enumerable: true,
  get: function get() {
    return _primitives.Primitive;
  }
});

var _staticTree = require('./staticTree');

Object.defineProperty(exports, 'createStaticTree', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_staticTree).default;
  }
});

var _Path = require('./Path');

Object.defineProperty(exports, 'Path', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Path).default;
  }
});
exports.sequence = sequence;
exports.parallel = parallel;

var _FunctionTree = require('./FunctionTree');

Object.defineProperty(exports, 'FunctionTree', {
  enumerable: true,
  get: function get() {
    return _FunctionTree.FunctionTree;
  }
});
Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _FunctionTree.FunctionTree;
  }
});

var _Provider = require('./Provider');

Object.defineProperty(exports, 'Provider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Provider).default;
  }
});

var _ResolveValue = require('./ResolveValue');

Object.defineProperty(exports, 'extractValueWithPath', {
  enumerable: true,
  get: function get() {
    return _ResolveValue.extractValueWithPath;
  }
});
Object.defineProperty(exports, 'resolveObject', {
  enumerable: true,
  get: function get() {
    return _ResolveValue.resolveObject;
  }
});
Object.defineProperty(exports, 'ResolveValue', {
  enumerable: true,
  get: function get() {
    return _ResolveValue.ResolveValue;
  }
});

var _Tag = require('./Tag');

Object.defineProperty(exports, 'createTemplateTag', {
  enumerable: true,
  get: function get() {
    return _Tag.createTemplateTag;
  }
});
Object.defineProperty(exports, 'Tag', {
  enumerable: true,
  get: function get() {
    return _Tag.Tag;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function sequence() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return new (Function.prototype.bind.apply(_primitives.Sequence, [null].concat(args)))();
}

function parallel() {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return new (Function.prototype.bind.apply(_primitives.Parallel, [null].concat(args)))();
}
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/function-tree/lib/index.js
// module id = 229
// module chunks = 0